/** 
 * 权限 
 */
import APIDOC from '../model/serverApi';
import { get, post } from '../model/request';


//权限相关=>
//角色相关==>
export function addRole(params = {}) { return post(APIDOC.AUTHORITY.C_role, params) }//增
export function deleteRole(roleId) { return get(APIDOC.AUTHORITY.D_role, { roleId }) }//删
export function getRoleList(params) { return post(APIDOC.AUTHORITY.R_role, params) }//查
export function getRoleOne(roleId) { return get(APIDOC.AUTHORITY.R_role_one, { roleId }) }//查一个
export function updateRole(params) { return post(APIDOC.AUTHORITY.U_role, params) }//改
export function getPermissionMenuList() { return get(APIDOC.AUTHORITY.R_permission_menuList) }//获取用户权限列表
export function getAllAuthorityMenuList() { return get(APIDOC.AUTHORITY.R_allAuthority_menuList) }//获取所有的权限列表
//菜单相关==>
export function addMenu(params = {}) { return post(APIDOC.AUTHORITY.C_menu, params) }//增
export function deleteMenu(menuId) { return get(APIDOC.AUTHORITY.D_menu, { menuId: menuId }) }//删
export function getMenuList(params) { return post(APIDOC.AUTHORITY.R_menu, params) }//查
// export function getMenuOne(MenuId){return get(APIDOC.AUTHORITY.R_menu_one,{MenuId})}//查一个
export function updateMenu(params) { return post(APIDOC.AUTHORITY.U_menu, params) }//改
//用户相关==>
export function addUser(params = {}) { return post(APIDOC.AUTHORITY.C_user, params) }//增
export function deleteUser(paramsArr) { return post(APIDOC.AUTHORITY.D_user, paramsArr) }//删
export function getUserList(params) { return post(APIDOC.AUTHORITY.R_user, params) }//查
export function getUserOne(userId) { return get(APIDOC.AUTHORITY.R_user_one, { userId }) }//查一个
export function updateUser(params) { return post(APIDOC.AUTHORITY.U_user, params) }//改
export function forbidenUser(userId) { return get(APIDOC.AUTHORITY.F_user, { userId }) }//禁用用户
export function resetPwd(userId) { return get(APIDOC.AUTHORITY.resetPwd, { userId }) }//重置密码
export function getCurrentUserByRoleList(userId) { return get(APIDOC.AUTHORITY.currentUser_roleList, { userId }) }//获取当前用户对应的角色列表
export function saveUserRole(params) { return post(APIDOC.AUTHORITY.saveUserRole, params) }//保存用户角色设置
//部门相关==>
export function addDept(params = {}) { return post(APIDOC.AUTHORITY.C_dept, params) }//增
export function deleteDept(deptId) { return get(APIDOC.AUTHORITY.D_dept, { deptId }) }//删
export function getDeptList(params) { return get(APIDOC.AUTHORITY.R_dept, { params }) }//查
export function updateDept(params) { return post(APIDOC.AUTHORITY.U_dept, params) }//改

//自定义上传相关==>
export function upload(params) { return post(APIDOC.UPLOAD, params, { headers: { 'Content-Type': "multipart/form-data" } }) }
export function uploadFile_base64(params) { return post(APIDOC.UPLOAD_base64, params) }

//系统设置==>
export function getSysConfigList(params) { return post(APIDOC.AUTHORITY.R_config, params) }//查
export function au_SysConfig(params = {}) { return post(APIDOC.AUTHORITY.CU_config, params) }//增
export function getSysConfigInfo(id) { return get(APIDOC.AUTHORITY.R_config_one, { configId: id }) }//查一个

//获取验证码
export function getValidateCodeImg() {
    return get(APIDOC.LOGIN.getValidateCodeImg())
}

//修改密码
export function updatePwd(params) { return post(APIDOC.UPDATE_PWD, params) };



// WEBPACK FOOTER //
// ./src/api/services/authority.js